/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_TabsInputs */

const cs_property_tabs = /** @type {(inputs: Property_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekce nemovitosti`)
};

const en_property_tabs = /** @type {(inputs: Property_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property sections`)
};

/**
* | output |
* | --- |
* | "Property sections" |
*
* @param {Property_TabsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tabs = /** @type {((inputs?: Property_TabsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_TabsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tabs(inputs)
	return cs_property_tabs(inputs)
});